import { IRouteConfig } from '@common/interfaces/route.interface';
import { lazy } from '@common/utils/lazy.util';
import { ILinkItem } from '@common/utils/make-links/make-links.util';
import { LINKS } from '@src/shared/links.constant';

interface IRedirects {
    to: ILinkItem;
    exact: boolean;
}

export const GET_REGISTER_ROUTES = (): IRouteConfig => {
    // common routes
    const routes = [
        {
            path: LINKS.register.invite,
            component: lazy(() =>
                import(/* webpackChunkName: "InviteContainer" */ './invite/containers/invite.container').then((module) => ({
                    default: module.InviteContainer,
                })),
            ),
            isPrivate: false,
            hasAccess: (): boolean => true,
        },
        {
            path: LINKS.register.testStripe,
            component: lazy(() =>
                import(/* webpackChunkName: "TestStripe" */ './test-stripe/containers/test-stripe.container').then(
                    (module) => ({
                        default: module.TestStripeContainer,
                    }),
                ),
            ),
            isPrivate: false,
            hasAccess: (): boolean => true,
        },
    ];

    const redirects: IRedirects[] = [];

    // RegistrationTestVariants
    {
        routes.push(
            {
                path: LINKS.register.checkDelivery,
                component: lazy(() =>
                    import(
                        /* webpackChunkName: "CheckDeliveryContainer" */ './check-delivery-step/container/check-delivery.container'
                    ).then((module) => ({
                        default: module.CheckDeliveryContainer,
                    })),
                ),
                isPrivate: false,
                hasAccess: (): boolean => true,
            },
            {
                path: LINKS.register.firstBox,
                component: lazy(() =>
                    import(
                        /* webpackChunkName: "FirstBoxTabContainer" */ './choose-box-step/container/choose-box.container'
                    ).then((module) => ({
                        default: module.ChooseBoxContainer,
                    })),
                ),
                isPrivate: false,
                hasAccess: (): boolean => true,
            },
            {
                path: LINKS.register.deliveryDetails,
                component: lazy(() =>
                    import(
                        /* webpackChunkName: "DeliveryDetailsContainer" */ './delivery-details-step/container/delivery-details.container'
                    ).then((module) => ({
                        default: module.DeliveryDetailsContainer,
                    })),
                ),
                isPrivate: false,
                hasAccess: (): boolean => true,
            },
            {
                path: LINKS.register.accountDetails,
                component: lazy(() =>
                    import(
                        /* webpackChunkName: "AccountDetailsContainer" */ './account-details-step/container/account-details.container'
                    ).then((module) => ({
                        default: module.AccountDetailsContainer,
                    })),
                ),
                isPrivate: false,
                hasAccess: (): boolean => true,
            },
            {
                path: LINKS.register.payment,
                component: lazy(() =>
                    import(
                        /* webpackChunkName: "RegistrationConfirmationContainer" */ './payment-details-step/container/payment-details.container'
                    ).then((module) => ({
                        default: module.PaymentDetailsContainer,
                    })),
                ),
                isPrivate: false,
                hasAccess: (): boolean => true,
            },
            {
                path: LINKS.register.summary,
                component: lazy(() =>
                    import(
                        /* webpackChunkName: "RegistrationConfirmationContainer" */ './registration-confirmation/registration-confirmation.container'
                    ).then((module) => ({
                        default: module.RegistrationConfirmation,
                    })),
                ),
                isPrivate: false,
                hasAccess: (): boolean => true,
            },
        );

        redirects.push({
            to: LINKS.register.checkDelivery,
            exact: true,
        });
    }

    return {
        routes,
        redirects,
    };
};
